import React from 'react';
import { PageHeader } from 'react-bootstrap';


class Download extends React.Component {
	render() { 
		return (
			<div className="pageContents">
				<PageHeader>Splinter Releases</PageHeader>
				<h3>1.1 Feature Roadmap</h3>
				<ol>
					<li>Improve Query field to actually support regex and wildcard expressions.</li>
					<li>Add auto-group options when right-clicking on a log.</li>
					<li>Add group exclusion (filter out) mechanism.</li>
					<li>Refactor and optimize main window to allow for multi-line logs.</li>
				</ol>
				

				<h3>Latest Release <small>August 6, 2017</small></h3>
				<h4><a href="http://bit.ly/1NuNXRT">version 1.0.4625</a></h4>
				<ul>
				    <li><small><b>New Feature</b></small> Drag and drop of local files and URL links now opens the file or the remote resource.</li>
					<li>Pasting logs directly works a little better now, you can paste them even with the address bar in focus.</li>
				</ul>


				<PageHeader><h2>Archive</h2></PageHeader>
				<h4>version 1.0.4605</h4>
				<ul>
					<li>Fixed copy-paste bug for adb logs.</li>
					<li><small><b>New Feature</b></small> Added log saving functionality. The logs are now saved along with an embedded definition.</li>
					<li><small><b>New Feature</b></small> Added support for saving graphs with SVG format.</li>
				</ul>
				<h4>version 1.0.4504</h4>
				<ul>
					<li>Fixed a bug with grouping fields which occasionally would prevent all groups from displaying correctly.</li>
					<li><small><b>New Feature</b></small> Added [ FINISHED ] in the progress bar when the process has ended.</li>
				</ul>
				<h4>version 1.0.4446</h4>
				<ul>
					<li>Fixed a EXC_BAD_INSTRUCTION (SIGILL) for 2012 and older macbooks.</li>
				</ul>
				<h4>version 1.0.4444</h4>
				<ul>
					<li>Fixed a 'Symbol not found: _clock_gettime' crash for MacOS 10.11 and below.</li>
				</ul>
				<h4>version 1.0.4438</h4>
				<ul>
					<li><small><b>New Feature</b></small> Added a generic symbol resolution for logs - allowing mapping of fields.</li>
					<li><small><b>New Feature</b></small> Added process id -> package name symbol resolution for adb commands.</li>
					<li><small><b>New Feature</b></small> New toasts will replace existing popups and provide better info.</li>
					<li><small><b>New Feature</b></small>  Added toasts for symbol loading.</li>
					<li>Minor bug fixes, performance improvements.</li>
				</ul>
				<h4>version 1.0.4186</h4>
				<ul>
					<li>Added support for accepting licenses.</li>
				</ul>
				<h4>version 1.0.4004</h4>
				<ul>
					<li>Fixed a bug with node name mapping for graphs.</li>
				</ul>
				<h4>version 1.0.4003</h4>
				<ul>
					<li>Fixed metrics bug.</li>
				</ul>
				<h4>version 1.0.4000</h4>
				<ul>
					<li>Fixed graph node colorization bug for log4j.</li>
					<li><small><b>New Feature</b></small> Added ~ functionality in the address bar, denoting user's home.</li>
				</ul>	
			</div>
			);
	}
}

export default Download;


// WEBPACK FOOTER //
// ./src/Download.js